var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.677 31.677",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.153,568.921A14.682,14.682,0,1,0,630.834,583.6h0a14.7,14.7,0,0,0-14.683-14.682m0,30.52a15.839,15.839,0,1,1,15.84-15.838,15.839,15.839,0,0,1-15.84,15.838",
    transform: "translate(-600.315 -567.764)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.965,576.886l-2.547,4.9h4.138Z",
    transform: "translate(-601.263 -568.831)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.638,583.288l7.8,11.111-3.608-11.111Z",
    transform: "translate(-601.288 -569.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.8,576.912h-4.61l1.488,4.584Z",
    transform: "translate(-601.703 -568.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.319,581.819l-3.511-4.622-3.147,4.622Z",
    transform: "translate(-601.993 -568.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.843,576.912h-4.782l3.3,4.343Z",
    transform: "translate(-602.508 -568.834)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.474,581.805H627.5l-2.416-4.723Z",
    transform: "translate(-603.024 -568.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.592,594.88a.217.217,0,0,1-.159.105.213.213,0,0,1-.157-.107l-9.183-13.084a.881.881,0,0,1-.052-.805l2.668-5.129a.875.875,0,0,1,.681-.419h12.242a.86.86,0,0,1,.676.419l2.676,5.23a.872.872,0,0,1-.059.8Zm-.082-24.069a13.147,13.147,0,1,0,13.149,13.147,13.147,13.147,0,0,0-13.149-13.147",
    transform: "translate(-600.672 -568.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.257,583.288l3.461,10.661,3.641-10.661Z",
    transform: "translate(-601.946 -569.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.867,594.43l8.007-11.143h-4.2Z",
    transform: "translate(-602.485 -569.58)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill10);
export default __webpack_public_path__ + "static/media/skill10.89ccd808.svg";
export { ForwardRef as ReactComponent };